<ul class="list-none p-0 m-0 border-top-1 border-300">
  @for (att of attributes; track $index) {
  <li
    class="flex align-items-center py-2 px-2 flex-wrap"
    [ngClass]="$index % 2 === 0 ? '' : 'surface-ground'"
  >
    <div class="text-500 w-full md:w-2 font-medium">
      {{ att.label | translate }}
    </div>
    <div class="text-600 w-full md:w-10">
      <div
        *ngIf="att.subfield; then nested_object_content; else normal_content"
      ></div>
      <ng-template #nested_object_content>
        <div
          *ngIf="
            att.childfield;
            then child_nested_object_content;
            else child_normal_content
          "
        ></div>
        <ng-template #child_nested_object_content>
          <label>{{ (data && data[att.field] && data[att.field][att.subfield] && data[att.field][att.subfield][att.childfield]) || '-' }}</label>
        </ng-template>
        <ng-template #child_normal_content>
          <label>{{ (data && data[att.field] && data[att.field][att.subfield]) || '-' }}</label>
        </ng-template>
      </ng-template>
      <ng-template #normal_content>
        <label>{{ (data && data[att.field]) || '-' }}</label>
      </ng-template>
    </div>
  </li>
  }
</ul>
